import { render, staticRenderFns } from "./IncidentTemplate.vue?vue&type=template&id=13b8ef24&"
import script from "./IncidentTemplate.vue?vue&type=script&lang=js&"
export * from "./IncidentTemplate.vue?vue&type=script&lang=js&"
import style0 from "./IncidentTemplate.vue?vue&type=style&index=0&id=13b8ef24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QInput,QBtn,QSelect,QItem,QItemSection,QItemLabel,QToggle,QCardActions,QDialog,QCardSection});qInstall(component, 'directives', {ClosePopup});
